var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"fill":"none","d":"M0-2h10V8H0z","key":0}),React.createElement("path",{"d":"M4.95 4.071L8.486.535 9.9 1.95 6.364 5.485 4.95 6.9 0 1.95 1.414.536 4.95 4.071z","key":1})]));
}

ArrowDown.defaultProps = {"width":"10","height":"7"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
